<ng-container>
  <span [title]="date | date: format:'UTC'">
    {{ date | date: format:'UTC' }}
  </span>
</ng-container>
